import React, { useEffect, useRef, useState } from 'react';

export default function CounterStat({ value, suffix = '', label, duration = 1900 }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const el = ref.current; if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started) {
          setStarted(true);
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.round(eased * value));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    io.observe(el); return () => io.disconnect();
  }, [value, duration, started]);

  return (
    <div ref={ref}>
      <div className="font-display text-6xl md:text-7xl lg:text-8xl num-counter leading-none">
        {n}<span className="text-[var(--coral)]">{suffix}</span>
      </div>
      <div className="mt-4 font-tag opacity-70">{label}</div>
    </div>
  );
}
